import { render } from "./easyship.vue?vue&type=template&id=47bb1510&scoped=true"
import script from "./easyship.vue?vue&type=script&lang=js"
export * from "./easyship.vue?vue&type=script&lang=js"

import "./easyship.vue?vue&type=style&index=0&id=47bb1510&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47bb1510"]])

export default __exports__